<template>
    <div class="error-page">
        <h1><slot name="code"></slot></h1>
        <section class="info">
            <h2><slot name="header"></slot></h2>
            <p>
                <slot name="description"></slot>
            </p>
        </section>
        <section class="logo">
            <a href="http://edito.pl" class="logo">
                <img src="data:image/png;base64,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" />
            </a>
        </section>
        <section class="back">
            <a href="/">
                <i class="arrow"></i>
                <span>{{ $t('[[[Wróć do strony głównej]]]') }}</span>
            </a>
        </section>
    </div>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';

@Options({})
export default class ErrorLayout extends Vue
{
}
</script>

<style lang="scss" scoped>
.error-page {
    --ico-arrow: url(data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgd2lkdGg9Ijc2OCIgaGVpZ2h0PSI3NjgiIHZpZXdCb3g9IjAgMCA3NjggNzY4Ij48dGl0bGU+PC90aXRsZT48ZyBpZD0iaWNvbW9vbi1pZ25vcmUiPjwvZz48cGF0aCBmaWxsPSIjMDAwIiBkPSJNNTc2IDM1MmgtMjMxLjgwOGw1MC43NTItNTAuNzUyYzI0Ljk5Mi0yNC45OTIgMjQuOTkyLTY1LjU2OCAwLTkwLjQ5Ni0yNC45OTItMjQuOTkyLTY1LjUwNC0yNC45OTItOTAuNDk2IDBsLTIwNS4yNDggMjA1LjI0OCAyMDUuMjQ4IDIwNS4yNDhjMTIuNDggMTIuNTEyIDI4Ljg2NCAxOC43NTIgNDUuMjQ4IDE4Ljc1MnMzMi43MzYtNi4yNCA0NS4yNDgtMTguNzUyYzI0Ljk5Mi0yNC45OTIgMjQuOTkyLTY1LjU2OCAwLTkwLjQ5NmwtNTAuNzUyLTUwLjc1MmgyMzEuODA4YzM1LjMyOCAwIDY0LTI4LjY3MiA2NC02NCAwLTM1LjM2LTI4LjY3Mi02NC02NC02NHoiPjwvcGF0aD48L3N2Zz4=);
    --error-bg: linear-gradient(to right, #0e1824 50%, #fff 50%);
    --error-color: #0e1824;

    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 100%;
    background: var(--error-bg);

    a {
        text-decoration: none;
    }
    h1 {
        font-size: 160px;
        font-weight: normal;
        letter-spacing: 30px;
        margin-right: -30px;
        color: #fff;
        mix-blend-mode: difference;
    }
    .info {
        position: absolute;
        bottom: 15%;
        left: 10%;
        right: 60%;
        color: #fff;
        mix-blend-mode: difference;

        h2 {
            margin-bottom: 18px;
            font-size: 45px;
            font-weight: 700;
            text-align: center;
        }
        p {
            text-align: center;
            font-size: 20px;
        }
    }
    .logo {
        position: absolute;
        bottom: 15%;
        right: 10%;
    }
    .back {
        position: absolute;
        top: 10%;
        right: 10%;

        a {
            font-size: 17px;
            font-weight: 700;
            color: var(--error-text-color);

            i.arrow {
                display: inline-block;
                width: 19px;
                height: 20px;
                margin-right: 7px;
                background-image: var(--ico-arrow);
                background-size: cover;
                transition-duration: 0.3s;
                font-size: 22px;
                vertical-align: -3px;
            }

            &:hover {
                text-decoration: none;

                i.arrow {
                    margin-right: 14px;
                }
            }
        }
    }
}

@media screen and (max-width: 1400px) {
    .error-page {
        .info {
            h2 {
                margin-bottom: 12px;
                font-size: 36px;
            }
            p {
                font-size: 16px;
            }
        }
    }
}

@media screen and (max-width: 1120px) {
    .error-page {
        .info {
            h2 {
                margin-bottom: 8px;
                font-size: 24px;
            }
            p {
                font-size: 13px;
            }
        }
        .back span {
            display: none;
        }
    }
}

@media screen and (max-width: 640px) {
    .error-page {
        h1 {
            font-size: 100px;
        }
        .info {
            left: 10%;
            right: 10%;
        }
        .logo {
            display: none;
        }
    }
}

@media screen and (max-height: 640px) {
    .error-page {
        .info {
            bottom: 10%;
        }
    }
}
</style>
